import { NumberInput, Select, Stack } from '@mantine/core';
import { getAppConfig } from '../../../../configs/apps/appConfigs';
import { scenarioMaps } from '../../../../data/maps';
import type { PerformanceQuickFormState } from '../types';
import { DEV_TOOLS_COMBOBOX_PROPS } from '../shared/comboboxProps';

type PerformanceQuickFormProps = {
  value: PerformanceQuickFormState;
  onChange: (next: PerformanceQuickFormState) => void;
};

export function PerformanceQuickForm({
  value,
  onChange,
}: PerformanceQuickFormProps) {
  const mapOptions = scenarioMaps.performance ?? [];
  const appConfig = getAppConfig('performance');
  const levelOptions = appConfig.stateOptions ?? [];

  return (
    <Stack gap='xs'>
      <Select
        label='Scenario'
        data={mapOptions}
        value={value.map}
        onChange={v =>
          onChange({ ...value, map: v ?? mapOptions[0]?.value ?? '' })
        }
        required
        comboboxProps={DEV_TOOLS_COMBOBOX_PROPS}
      />
      <Select
        label='Livello'
        data={levelOptions}
        value={value.currentState}
        onChange={v =>
          onChange({
            ...value,
            currentState: v ?? appConfig.defaultLevel ?? 'p-2',
          })
        }
        comboboxProps={DEV_TOOLS_COMBOBOX_PROPS}
      />
      <NumberInput
        label='Variazione %'
        min={0}
        value={value.variation}
        onChange={v =>
          onChange({
            ...value,
            variation: typeof v === 'number' ? v : Number(v) || 0,
          })
        }
      />
      <NumberInput
        label='Durata (s)'
        min={1}
        value={value.duration}
        onChange={v =>
          onChange({
            ...value,
            duration: typeof v === 'number' ? v : Number(v) || 1,
          })
        }
      />
    </Stack>
  );
}
